import { render, staticRenderFns } from "./default-form.vue?vue&type=template&id=51d2a062&"
import script from "./default-form.vue?vue&type=script&lang=js&"
export * from "./default-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports